import {
  Button,
  Checkbox,
  makeStyles,
  Dialog,
  DialogContent,
  DialogContentText,
  DialogTitle,

} from "@material-ui/core";
import React from "react";
import { useTranslation } from "react-i18next";
import { COLORS } from "../../constant/colors";
import depressionSvg from "../../assets/eTriage/landing/depression.svg";
import anxietySvg from "../../assets/eTriage/landing/anxiety.svg";
import heroBannerSvg from "../../assets/eTriage/landing/heroBanner.svg";
import desktopHeroBannerSvg from "../../assets/eTriage/landing/desktopHeroBanner.svg";
import desktopHeroBannerBackground from "../../assets/eTriage/landing/desktopHeroBannerBackground.svg";

import personalAndSocialImpairmentSvg from "../../assets/eTriage/landing/personalAndSocialImpairment.svg";
import ClientValidationForm from "./components/ClientValidationForm";
import { MaxWidth } from "../../constant/stylesSize";
import koaHealthLogoDark from "../../assets/KoaStacked_BlackMed.png";

import ReactHtmlParser from "react-html-parser";

import DialogCloseButtonRow from "../components/DialogCloseButtonRow";
import TagManager from "react-gtm-module";

const useStyles = makeStyles((theme) => ({
  pageContainer: {
    flex: 1,
    background: COLORS.fwdOrange,
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
  },

  headerbanner: {
    height: 300,
    width: "100%",
    paddingTop: 100,
    background: COLORS.headerBackgroundColor,
    backgroundImage: `url(${heroBannerSvg})`,
    // backgroundImage: url("../../assets/eTriage/landing/heroBanner.svg"),
    [theme.breakpoints.up("md")]: {
      backgroundRepeat: "no-repeat, repeat-x",
      backgroundImage: `url(${desktopHeroBannerSvg}), url(${desktopHeroBannerBackground})`,
      backgroundPosition: "right bottom",
      height: 350,
      alignItems: "center",
      display: "flex",
      flexDirection: "column",
      paddingLeft: 70,
      paddingRight: 70,
    },
  },
  contentContainer: {
    maxWidth: MaxWidth,
    width: "100%",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    alignItems: "flex-start",
    [theme.breakpoints.up("md")]: {
      padding: 0,
      alignItems: "flex-start",
    },
  },
  description: {
    color: COLORS.white,
    padding: 20,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    [theme.breakpoints.up("md")]: {
      alignItems: "center",
      paddingLeft: 70,
      paddingRight: 70,
    },
  },
  descriptionHeader: {
    fontSize: 20,
    fontWeight: 700,
    lineHeight: "25px",
  },
  descriptionCaption: {
    fontSize: 16,
    fontWeight: 450,
    lineHeight: "24px",
  },
  descriptionPointIcon: {
    width: 30,
    height: 30,
    marginRight: 20,

    [theme.breakpoints.up("md")]: {
      width: 260,
      height: 80,
      marginRight: 0,
    },
  },
  descriptionPointsGroup: {
    fontSize: 20,
    fontWeight: 700,
    lineHeight: "25px",
    marginTop: 20,
    marginBottom: 20,
    display: "flex",
    flexDirection: "column",
    [theme.breakpoints.up("md")]: {
      flexDirection: "row",
      lineHeight: "40px",
    },
  },
  descriptionPoint: {
    display: "flex",
    flexDirection: "row",
    alignItems: "start",
    marginTop: 20,
    [theme.breakpoints.up("md")]: {
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      marginTop: 20,
    },
  },
  symptomsLabelContainer: {
    display: "flex",
    flexDirection: "column",
    [theme.breakpoints.up("md")]: {
      alignItems: "center",
    },
  },
  symptomsLabel: {
    textAlign: "left",
    [theme.breakpoints.up("md")]: {
      textAlign: "center",
    },
  },
  symptomsQuestionsNumber: {
    marginTop: 0,
    fontSize: 16,
    fontWeight: 450,
    lineHeight: "24px",
  },
  consentSection: {
    display: "flex",
    flexDirection: "row",
    alignItems: "baseline",
    fontSize: 16,
    fontWeight: 450,
    lineHeight: "22px",
  },
  checkbox: {
    color: COLORS.white,
    "& .MuiSvgIcon-root": {
      width: 24,
      height: 24,
    },
    "& .Mui-checked": {
      color: COLORS.fwdOrange,
    },
  },

  bottomButtonSection: {
    background: COLORS.white,
    width: "100%",
    marginTop: 20,
    // height: 200,
    // position: "fixed",
    bottom: 0,
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    background: COLORS.white,
    boxShadow: "0px -8px 8px rgba(0, 0, 0, 0.08)",
    padding: "20px",
    [theme.breakpoints.up("md")]: {
      display: "none",
    },
  },
  bottomButtonSectionNote: {
    fontSize: 16,
    fontWeight: 450,
    lineHeight: "24px",
    marginBottom: 15,
    color: COLORS.white,
    [theme.breakpoints.down("sm")]: {
      color: COLORS.fwdDarkGreen,
    },
  },
  startButton: {
    background: COLORS.fwdOrange,
    color: COLORS.white,
    height: 50,
    width: "100%",
    borderRadius: 8,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    cursor: "pointer",
    "&:hover": {
      background: COLORS.fwdOrange20,
    },
    "&:disabled": {
      background: COLORS.fwdOrange20,
      color: COLORS.white,
    },
  },
  desktopButtonSection: {
    paddingTop: 20,
    [theme.breakpoints.down("sm")]: {
      display: "none",
    },
  },
  desktopStartButton: {
    background: COLORS.white,
    color: COLORS.fwdOrange,
    height: 50,
    width: 343,
    borderRadius: 8,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    cursor: "pointer",
    "&:hover": {
      background: COLORS.fwdOrange20,
    },
    "&:disabled": {
      background: COLORS.fwdGrey,
      color: COLORS.fwdOrange50,
    },
  },
  startButtonText: {
    fontSize: 16,
    fontWeight: 700,
    lineHeight: "20px",
    textTransform: "none",
  },

  mindStrengthProgrammeTitle: {
    marginTop: 20,
    fontSize: 38,
    fontWeight: 700,
    lineHeight: "49px",

    [theme.breakpoints.down("sm")]: {
      marginLeft: 20,
      marginTop: 20,
      fontSize: 25,
      lineHeight: "31px",
    },
  },
  dialogPaper: {
    borderRadius: 10,
    minWidth: 400,
    [theme.breakpoints.down("sm")]: {
      borderRadius: "10px 10px 0px 0px",
      position: "fixed",
      bottom: 0,
      width: "100%",
      maxWidth: "100%",
      margin: 0,
    },
  },
  poweredBy: {
    display: "flex",
    flexDirection: "row",
    color: COLORS.fwdDarkGreen,
    fontSize: 14,
    fontWeight: 450,
    lineHeight: "21px",
    alignItems: "center",
    [theme.breakpoints.down("sm")]: {
      marginLeft: 20,
    },
  },
  koaHealthLogo: {
    height: 40,
    marginLeft: 5,
    cursor: "pointer",
  },
  koaHealthLogoImg: {
    height: "100%",
  },
  clickableSpan: {
    fontWeight: "bold",
    cursor: "pointer",
    textDecoration: "underline",
  },
  emergencyHint: {
    marginTop: 20,
    marginBottom: 10,
    color: COLORS.white,
    "& a": {
      color: COLORS.white,
    },
    [theme.breakpoints.down("sm")]: {
      color: COLORS.fwdDarkGreen,
      "& a": {
        color: COLORS.fwdDarkGreen,
      },
    },
  },
}));

const ETriageLanding = ({ changePage }) => {
  const classes = useStyles();
  const { t, i18n } = useTranslation();
  const [checked, setChecked] = React.useState(true);
  const [validationDialogOpen, setValidationDialogOpen] = React.useState(false);
  const [open, setOpen] = React.useState(false);
  const [tncOpen, setTncOpen] = React.useState(false);

  const [scroll, setScroll] = React.useState("paper");
  const currentBu = process.env.REACT_APP_BU ?? "hk";

  const handleTncClickOpen = () => {
    setTncOpen(true);
  };

  const handleTncClose = () => {
    setTncOpen(false);
  };

  const handlePrivacyPolicyGroupClick = () => {
    const groupPrivacyPolicyUrl =
      i18n.language == "tc"
        ? process.env.REACT_APP_PRIVACY_POLICY_GROUP_TC
        : process.env.REACT_APP_PRIVACY_POLICY_GROUP_EN;
    window.open(groupPrivacyPolicyUrl);
  };

  const handlePrivacyPolicyBuClick = () => {
    const buPrivacyPolicyUrl =
      i18n.language == "tc"
        ? process.env.REACT_APP_PRIVACY_POLICY_BU_HK_TC
        : process.env.REACT_APP_PRIVACY_POLICY_BU;
    window.open(buPrivacyPolicyUrl);
  };

  const handleClickOpen = () => () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };
  const handleValidationDialog = (shouldOpen) => {
    setValidationDialogOpen(shouldOpen);
  };

  const handleStartButtonOnClick = () => {
    //GA
    const tagEventArgs = {
      dataLayer: {
        event: "buttonClick",
        buttonTitle: "start now",
        pageUrl: window.location.href,
        language: i18n.language,
        componentName: "button",
      },
    };

    TagManager.dataLayer(tagEventArgs);

    if (process.env.REACT_APP_NEED_POLICY_VALIDATION == "true" || process.env.REACT_APP_ALLOW_NON_CUSTOMER == "true") {
      handleValidationDialog(true);
    } else {
      changePage("", false, {});
    }
  };

  const tagGoArgs = (planCode = "") => {
    return {
      dataLayer: {
        event: "validate",
        buttonTitle: "go",
        pageUrl: window.location.href,
        componentName: "button",
        language: i18n.language,
        planCode: planCode
      }
    }
  };

  const handleValidationSuccess = (clientId, policyData) => {
    TagManager.dataLayer(tagGoArgs(policyData.productCode));
    changePage(clientId, true, policyData);
  };


  const handleIsCustomerSelectSuccess = (isCustomer) => {
    TagManager.dataLayer(tagGoArgs(""));
    changePage("", isCustomer, {});
  };

  const renderConsent = () => {
    return (
      <div>
        {t(`eTriageLanding.consent.${currentBu}`)}
        <span
          className={classes.clickableSpan}
          onClick={() => {
            handleTncClickOpen();
          }}
        >
          {t("eTriageLanding.tNc")}
        </span>
        {t("eTriageLanding.consentComma")}

        <span
          className={classes.clickableSpan}
          onClick={() => {
            handlePrivacyPolicyGroupClick();
          }}
        >
          {t("eTriageLanding.FWDGroupPrivacyNotice")}
        </span>
        {t("eTriageLanding.consentAnd")}
        <span
          className={classes.clickableSpan}
          onClick={() => {
            handlePrivacyPolicyBuClick();
          }}
        >
          {t(`eTriageLanding.${currentBu}`)}
          {t(`eTriageLanding.privacyPolicy`)}
        </span>

        {t("eTriageLanding.consentEnd")}
      </div>
    );
  };

  return (
    <>
      <div component="section" className={classes.pageContainer}>
        <div>
          <div className={classes.headerbanner}>
            <div className={classes.contentContainer}>
              <div className={classes.mindStrengthProgrammeTitle}>
                {ReactHtmlParser(t(`eTriageLanding.mindStrengthProgramme`))}
              </div>
              <div className={classes.poweredBy}>
                {t("poweredBySection.poweredBy")}
                <div
                  className={classes.koaHealthLogo}
                  onClick={handleClickOpen()}
                >
                  <img
                    src={koaHealthLogoDark}
                    className={classes.koaHealthLogoImg}
                  />
                </div>
                {t("poweredBySection.poweredBy_2")}
              </div>
            </div>
          </div>
          <div className={classes.description}>
            <div className={classes.contentContainer}>
              <div className={classes.descriptionHeader}>
                {t("eTriageLanding.title")}
              </div>
              <div className={classes.descriptionCaption}>
                {t("eTriageLanding.description")}
              </div>
              <div className={classes.descriptionPointsGroup}>
                <div className={classes.descriptionPoint}>
                  <img
                    src={depressionSvg}
                    className={classes.descriptionPointIcon}
                  />
                  <div className={classes.symptomsLabelContainer}>
                    <div className={classes.symptomsLabel}>
                      {t("eTriageLanding.depressionsymptoms")}
                    </div>
                    <div className={classes.symptomsQuestionsNumber}>
                      (9 {t("eTriageLanding.questions")})
                    </div>
                  </div>
                </div>
                <div className={classes.descriptionPoint}>
                  <img
                    src={anxietySvg}
                    className={classes.descriptionPointIcon}
                  />
                  <div className={classes.symptomsLabelContainer}>
                    <div className={classes.symptomsLabel}>
                      {t("eTriageLanding.anxietySymptoms")}
                    </div>
                    <div className={classes.symptomsQuestionsNumber}>
                      (7 {t("eTriageLanding.questions")})
                    </div>
                  </div>
                </div>
                <div className={classes.descriptionPoint}>
                  <img
                    src={personalAndSocialImpairmentSvg}
                    className={classes.descriptionPointIcon}
                  />
                  <div className={classes.symptomsLabelContainer}>
                    <div className={classes.symptomsLabel}>
                      {t("eTriageLanding.personalAndSocialImpairment")}
                    </div>
                    <div className={classes.symptomsQuestionsNumber}>
                      (5 {t("eTriageLanding.questions")})
                    </div>
                  </div>
                </div>
              </div>

              <div className={classes.consentSection}>
                <div>
                  <Checkbox
                    color="default"
                    checked={checked}
                    className={`${classes.checkbox}`}
                    onChange={(e) => {
                      setChecked(e.target.checked);
                    }}
                  />
                </div>

                {renderConsent()}
              </div>

              <div className={classes.desktopButtonSection}>
                <div className={classes.bottomButtonSectionNote}>
                  {process.env.REACT_APP_NEED_POLICY_VALIDATION == "true" &&
                    t(`eTriageLanding.mayNeedToValidateNote.${currentBu}`)}
                </div>
                <div className={classes.emergencyHint}>
                  {ReactHtmlParser(
                    t(`eTriageLanding.emergencyHint.${currentBu}`)
                  )}
                </div>
                <Button
                  disabled={!checked}
                  className={classes.desktopStartButton}
                  onClick={() => {
                    handleStartButtonOnClick();
                  }}
                >
                  <div className={classes.startButtonText}>
                    {t("eTriageLanding.startNow")}
                  </div>
                </Button>
              </div>

              {/* <div style={{ height: 200 }}></div> */}
            </div>
          </div>
        </div>
        <div className={classes.bottomButtonSection}>
          <div className={classes.bottomButtonSectionNote}>
            {process.env.REACT_APP_NEED_POLICY_VALIDATION == "true" &&
              t(`eTriageLanding.mayNeedToValidateNote.${currentBu}`)}
          </div>
          <Button
            disabled={!checked}
            className={classes.startButton}
            onClick={() => {
              handleStartButtonOnClick();
            }}
          >
            <div className={classes.startButtonText}>
              {t("eTriageLanding.startNow")}
            </div>
          </Button>
          <div className={classes.emergencyHint}>
            {ReactHtmlParser(t(`eTriageLanding.emergencyHint.${currentBu}`))}
          </div>
        </div>
      </div>
      <Dialog
        classes={{ paper: classes.dialogPaper }}
        open={validationDialogOpen}
        onClose={() => {
          handleValidationDialog(false);
        }}
      >
        <ClientValidationForm validationSuccess={handleValidationSuccess} isCustomerResponse={handleIsCustomerSelectSuccess} checkPolicy={process.env.REACT_APP_NEED_POLICY_VALIDATION == 'true'} allowNonCustomer={process.env.REACT_APP_ALLOW_NON_CUSTOMER == 'true'} />
      </Dialog>
      <Dialog
        open={open}
        onClose={handleClose}
        scroll={"paper"}
        aria-labelledby="scroll-dialog-title"
        aria-describedby="scroll-dialog-description"
      >
        <DialogCloseButtonRow handleClose={handleClose} />
        <DialogContent dividers={scroll === "paper"}>
          <DialogContentText
            id="scroll-dialog-description"
            // ref={descriptionElementRef}
            tabIndex={-1}
          >
            {ReactHtmlParser(t(`poweredBySection.koaHealthIntro.${currentBu}`))}
          </DialogContentText>
        </DialogContent>
      </Dialog>
      <Dialog
        open={tncOpen}
        onClose={handleTncClose}
        scroll={"paper"}
        aria-labelledby="scroll-dialog-title"
        aria-describedby="scroll-dialog-description"
      >
        <DialogCloseButtonRow handleClose={handleTncClose} />
        <DialogTitle id="scroll-dialog-title">
          {t(`tNcTitle.${currentBu}`, {
            ns: "landingPageLongText",
          })}
        </DialogTitle>
        <DialogContent dividers={scroll === "paper"}>
          <DialogContentText id="scroll-dialog-description" tabIndex={-1}>
            {ReactHtmlParser(
              t(`tNcDetails.${currentBu}`, {
                ns: "landingPageLongText",
              })
            )}
          </DialogContentText>
        </DialogContent>
      </Dialog>
    </>
  );
};

export default ETriageLanding;
